```vue
<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <a href="javascript:void(0)">Overall Inventory Reports</a>
                    </li>
                </ol>
                <h4 class="main-title mb-0">Overall Inventory Reports</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Overall Inventory Reports</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-4">
                                <label class="form-label">From Date</label>
                                <input class="form-control mb-3" type="date" v-model="meta.from_date" :class="{ 'is-invalid': errors.from_date }">
                                <span v-if="errors.from_date" class="invalid-feedback">{{ errors.from_date[0] }}</span>
                            </div>
                            <div class="col-4">
                                <label class="form-label">To Date</label>
                                <input class="form-control mb-3" type="date" v-model="meta.to_date" :class="{ 'is-invalid': errors.to_date }">
                                <span v-if="errors.to_date" class="invalid-feedback">{{ errors.to_date[0] }}</span>
                            </div>
                            <div class="col-4 mt-auto">
                                <button class="btn mb-3 btn-primary me-2" @click="search">Search</button>
                                <!-- <button class="btn mb-3 btn-danger" @click="reset">Reset</button> -->
                            </div>
                        </div>

                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-striped table-bordered mb-0">
                                <thead>
                                <tr style="background-color:#9b9b9b; color:white;">
                                    <th class="text-center">#</th>
                                    <th>
                                        Spare
                                        <span>
                                            <i v-if="meta.keyword === 'spare_id' && meta.order_by === 'asc'"></i>
                                            <i v-else-if="meta.keyword === 'spare_id' && meta.order_by === 'desc'"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th>
                                        Opening Stock
                                        <span>
                                            <i v-if="meta.keyword === 'opening_stock' && meta.order_by === 'asc'"></i>
                                            <i v-else-if="meta.keyword === 'opening_stock' && meta.order_by === 'desc'"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th>
                                        Inward Stock
                                        <span>
                                            <i v-if="meta.keyword === 'inward_stock' && meta.order_by === 'asc'"></i>
                                            <i v-else-if="meta.keyword === 'inward_stock' && meta.order_by === 'desc'"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th>
                                        Outward Stock
                                        <span>
                                            <i v-if="meta.keyword === 'outward_stock' && meta.order_by === 'asc'"></i>
                                            <i v-else-if="meta.keyword === 'outward_stock' && meta.order_by === 'desc'"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th>
                                        Closing Stock
                                        <span>
                                            <i v-if="meta.keyword === 'closing_stock' && meta.order_by === 'asc'"></i>
                                            <i v-else-if="meta.keyword === 'closing_stock' && meta.order_by === 'desc'"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="stock_summary.length === 0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(item, index) in stock_summary" :key="index">
                                        <td class="text-center">{{ meta.from + index }}</td>
                                        <td>{{ item.spare?.spare_name }}</td>
                                        <td>{{ item.opening_quantity }}</td>
                                        <td>{{ item.inward_quantity }}</td>
                                        <td>{{ item.outward_quantity }}</td>
                                        <td :style="{ color: item.closing_stock < 0 ? 'red' : '' }">{{ item.closing_stock }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select form-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import moment from "moment";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            meta: {
                order_by: 'asc',
                keyword: 'spare_id',
                per_page: 10,
                totalRows: 0,
                page: 1,
                lastPage: 1,
                from: 1,
                to: 1,
                maxPage: 1,
                from_date: '',
                to_date: ''
            },
            stock_summary: [],
            errors: []
        }
    },
    mounted() {
        this.meta.from_date = moment().format('YYYY-MM-DD');
        this.meta.to_date = moment().format('YYYY-MM-DD');
        this.index();
    },
    methods: {
        index() {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'paginateInventoryStocks', data: vm.meta })
                .then(response => {
                    loader.hide();
                    vm.stock_summary = response.data.data;
                    vm.meta.totalRows = response.data.total;
                    vm.meta.page = response.data.current_page;
                    vm.meta.per_page = response.data.per_page;
                    vm.meta.lastPage = response.data.last_page;
                    vm.meta.from = (vm.meta.page - 1) * vm.meta.per_page + 1;
                    const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                    vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(error => {
                    loader.hide();
                    vm.errors = error.response.data.errors || [];
                    vm.$store.dispatch('error', error.response.data.message || 'Failed to load data');
                });
        },
        reset() {
            this.meta.from_date = moment().format('YYYY-MM-DD');
            this.meta.to_date = moment().format('YYYY-MM-DD');
            this.meta.page = 1;
            this.meta.keyword = 'spare_id';
            this.meta.order_by = 'asc';
            this.meta.per_page = 10;
            this.errors = [];
            this.index();
        },
        search() {
            this.meta.page = 1;
            this.index();
        },
        onPageChange(page) {
            this.meta.page = page;
            this.index();
        },
        onPerPageChange() {
            this.meta.page = 1;
            this.index();
        },
        sort(field) {
            const fieldMap = {
                'opening_stock': 'opening_quantity',
                'inward_stock': 'inward_quantity',
                'outward_stock': 'outward_quantity',
                'closing_stock': 'closing_stock',
                'spare_id': 'spare_id'
            };
            this.meta.keyword = fieldMap[field] || field;
            this.meta.order_by = this.meta.order_by === 'asc' ? 'desc' : 'asc';
            this.index();
        }
    }
}
</script>